import React, { useState } from "react";
import { isUndefined } from "lodash";
import systemAlert from "../../../../utils/systemAlert";

import Modal, { ModalHeader } from "../../../../components/Modal";
import { ModalBody } from "reactstrap";
import Col from "../../../../components/ContentLayout/Col";
import Row from "../../../../components/ContentLayout/Row";
import DataComponent from "../../../../components/DataComponent";
import DatePicker from "../../../../components/DatePicker";
import Select from "../../../../components/Select";
import Button from "../../../../components/Button";

import { excelUploadSalariesHistories, excelUploadSalariesHistoriesToBusiness } from "../../../../apis/salary/salary-history";
import semuSampleFile from "../../../../assets/file/semuSample.xlsx";
import theZoneSampleFile from "../../../../assets/file/theZoneSample.xlsx";
import semuBizSampleFile from "../../../../assets/file/semuBizSampleFile.xlsx";
import theZoneBizSampleFile from "../../../../assets/file/theZoneBizSampleFile.xlsx";
import { isFunction } from "lodash";

const SalaryFileUpload = ({ open, setOpen, setIsLoading, filterSubmit, setIsEmployeeCodeModal }) => {

  const [exposureDate, setExposureDate] = useState("");
  const [isWecakeCode, setIsWecakeCode] = useState(1);

  const uploadSalaryExcelFile = (e, type, salaryType = "normal") => {
    e.preventDefault();

    const file = e.target.files[0];
    if (isUndefined(file)) return;
    const formData = new FormData();
    formData.append("file", file);
    formData.append("exposureDate", exposureDate);
    formData.append("isWecakeCode", isWecakeCode);

    //console.log("uploadSalaryExcelFile: ", formData)

    let api;

    switch (salaryType) {
      case "business":
        api = excelUploadSalariesHistoriesToBusiness;
        break;
      default:
        api = excelUploadSalariesHistories;
        break;
    }


    if (isFunction(api)) {
      setIsLoading(true);
      api(type, formData)
        .then((res) => {
          filterSubmit();
          systemAlert('급여가 등록되었습니다.');
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const excelButtons = [
    {
      color: "text",
      size: "sm",
      type: 'button',
      label: (
        <>
          세무사랑 급여 샘플 <i className="mdi mdi-arrow-collapse-down" />
        </>
      ),
      action: () => {
        const a = document.createElement("a");
        a.href = semuSampleFile;
        a.style.display = "none";
        a.download = "semuSampleFile";
        document.body.appendChild(a);
        a.click();
      },
    },
    {
      label: "세무사랑 급여 엑셀 업로드",
      color: "gray-line",
      size: "sm",
      key: "semu",
      type: "excelfile",
      onChange: (e) => uploadSalaryExcelFile(e, 'semu'),
    },
    {
      color: "text",
      size: "sm",
      type: 'button',
      label: (
        <>
          더존 급여 샘플 <i className="mdi mdi-arrow-collapse-down" />
        </>
      ),
      action: () => {
        const a = document.createElement("a");
        a.href = theZoneSampleFile;
        a.style.display = "none";
        a.download = "theZoneSampleFile";
        document.body.appendChild(a);
        a.click();
      },
    },
    {
      label: "더존 급여 엑셀 업로드",
      color: "gray-line",
      size: "sm",
      key: "theZone",
      type: "excelfile",
      onChange: (e) => uploadSalaryExcelFile(e, 'theZone'),
    },
    {
      label: "타솔루션 직원코드 등록",
      color: "gray-line",
      size: "sm",
      type: 'button',
      action: (e) => {
        e.preventDefault();
        setIsEmployeeCodeModal(true);
      },
    },
    {
      label: "세무사랑 급여 엑셀 업로드",
      color: "gray-line",
      size: "sm",
      key: "semu_business",
      type: "excelfile",
      onChange: (e) => uploadSalaryExcelFile(e, 'semu', "business")
    },
    {
      color: "text",
      size: "sm",
      type: 'button',
      label: (
        <>
          세무사랑 급여 샘플 <i className="mdi mdi-arrow-collapse-down" />
        </>
      ),
      action: () => {
        const a = document.createElement("a");
        a.href = semuBizSampleFile;
        a.style.display = "none";
        a.download = "semuBizSampleFile";
        document.body.appendChild(a);
        a.click();
      },
    },
    {
      label: "더존 급여 엑셀 업로드",
      color: "gray-line",
      size: "sm",
      key: "theZone_business",
      type: "excelfile",
      onChange: (e) => uploadSalaryExcelFile(e, 'theZone', "business"),
    },
    {
      color: "text",
      size: "sm",
      type: 'button',
      label: (
        <>
          더존 급여 샘플 <i className="mdi mdi-arrow-collapse-down" />
        </>
      ),
      action: () => {
        const a = document.createElement("a");
        a.href = theZoneBizSampleFile;
        a.style.display = "none";
        a.download = "theZoneBizSampleFile";
        document.body.appendChild(a);
        a.click();
      },
    },
  ];

  const cancel = () => {
    setOpen(false);
  };

  return (
    <Modal size="md" isOpen={open} close={cancel}>
      <ModalHeader>급여 엑셀 업로드</ModalHeader>
      <ModalBody>
        <Row>
          <Col sm={6} style={{ textAlign: 'center' }}></Col>
          <Col sm={6} style={{ textAlign: 'center' }}>
            <DataComponent field={{ ...excelButtons[4] }} />
          </Col>
        </Row>
        <Row>
          <Col sm={12} style={{ height: 30 }}></Col>
        </Row>
        <Row>
          <Col sm={6} style={{ textAlign: 'center' }}>
            <label>사용 직원코드</label>
          </Col>
          <Col sm={6} style={{ textAlign: 'center' }}>
            <Select
              value={isWecakeCode}
              onChange={(e) => setIsWecakeCode(e.target.value)}
              list={[
                { label: "wecake 직원코드", value: 1 },
                { label: "타솔루션 직원코드", value: 2 },
              ]}
            ></Select>
          </Col>
        </Row>
        <Row>
          <Col sm={12} style={{ height: 15 }}></Col>
        </Row>
        <Row>
          <Col sm={6} style={{ textAlign: 'center' }}>
            <label>노출일</label>
          </Col>
          <Col sm={6} style={{ textAlign: 'left' }}>
            <DatePicker
              onChange={(date) => {
                setExposureDate(date.datepicker.toString());
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={12} style={{ height: 20 }}><hr /></Col>
        </Row>
        <Row>
          <Col sm={12} style={{
            height: 40,
            textAlign: 'center',
            fontSize: 16,
            lineHeight: "40px",
          }}
            className="font-bold"
          >
            <span>일반급여</span>
          </Col>
        </Row>
        <Row>
          <Col style={{ textAlign: 'center', }}>
            <DataComponent field={{ ...excelButtons[1] }} />
            <DataComponent field={{ ...excelButtons[0] }} />

          </Col>
          <Col style={{ textAlign: 'center', }}>
            <DataComponent field={{ ...excelButtons[3] }} />
            <DataComponent field={{ ...excelButtons[2] }} />
          </Col>
        </Row>
        <Row>
          <Col sm={12} style={{ height: 20 }}><hr /></Col>
        </Row>
        <Row>
          <Col sm={12} style={{
            height: 40,
            textAlign: 'center',
            fontSize: 16,
            lineHeight: "40px",
          }}
            className="font-bold"
          >
            <span>사업소득자</span>
          </Col>
        </Row>
        <Row>
          <Col style={{ textAlign: 'center', }}>
            <DataComponent field={{ ...excelButtons[5] }} />
            <DataComponent field={{ ...excelButtons[6] }} />
          </Col>
          <Col style={{ textAlign: 'center', }}>
            <DataComponent field={{ ...excelButtons[7] }} />
            <DataComponent field={{ ...excelButtons[8] }} />
          </Col>
        </Row>
      </ModalBody>
      <div className="select-client-info">
        <div className="submit-button-wrap float-right margin-top-32">
          <Button
            className="button"
            //size="lg"
            label="닫기"
            color="gray-line"
            action={cancel}
          />
        </div>
      </div>
    </Modal>
  );
};

export default SalaryFileUpload;
